import { entityMapper } from '../entity/entity-mapper';

let transform = require('node-json-transform').transform;

export function transactionChangeUnitMapper(data: any) {
  console.log(data);
  var map = {
    /*
      node json mapper default item
      used to map one key to another
    */
    item: {
      name: 'name',
      id: 'dsdId',
      tfId: 'id',
      agents: 'agents',
      layers: 'layers',
      gsiList: 'gsiList',
      membershipList: 'membershipList',
      isReserved: 'isReserved',
      status: 'status',
      dsdStatus: 'dsdStatus',
      designTimeRights: 'designTimeRights',
      txnTimeRights: 'txnTimeRights',
      displayName: 'displayName',
      description: 'description',
      ontology: 'ontology',
      keywords: 'keywords',
      attachments: 'attachments',
      nextTriggerSet: 'nextTriggerSet',
      referencedChangeUnit: 'dsdReferencedChangeUnit',
      index: 'index',
      author: 'author',
      ownerId: 'ownerId',
      version: 'version',
      masterId: 'masterId',
      cuSystemProperties: 'cuSystemProperties',
      finishType: 'finishType',
      slotItemProperties: 'result.slotItemProperties',
      source: 'source',
      tCUConditionalPotentiality: 'tCUConditionalPotentiality',
      tCUConditionalPotentialityNames: 'tCUConditionalPotentialityNames',
      reservedCUType: 'reservedCUType',
      isNameUpdated: 'isNameUpdated',
      uiProperties: 'uiProperties',
      isFinal: 'isFinal', //  Usedfor final cu save
      oldVersionId: 'oldVersionId',
      estimatedTime: 'estimatedTime',
      gsiMasterId: 'gsiMasterId',
      triggerCUIndex: 'triggerCUIndex',
      cuMasterId: 'cuMasterId',
      gsiName: 'gsiName',
      cuName: 'cuName',
    },

    operate: [
      {
        run: function (val: any) {
          /*istanbul ignore next*/
          if (val?.length > 0) {
            /*istanbul ignore next*/
            return val?.map((y: any) => {
              return { ...y };
            });
          } else {
            return [];
          }
        },
        on: 'nextTriggerSet',
      },
      {
        run: function (val: any) {
          return transform(val, nestedMap);
        },
        on: 'layers',
      },
      {
        run: (val: any) => {
          if (val !== undefined && Object.keys(val).length) {
            return val;
          } else {
            return {};
          }
        },
        on: 'uiProperties',
      },
    ],
  };

  const nestedMap = {
    item: {
      label: 'label',
      participatingItems: 'participatingItems',
      type: 'type',
    },
    operate: [
      {
        run: function (val: any) {
          return val?.map((x: any) => {
            return {
              ...entityMapper(x?.item?.DATA),
              changeDriverMetaData: x.changeDriverMetaData,
              participatingItemId: x?.id,
              isMultiValue: x.isMultiValue,
            };
          });
        },
        on: 'participatingItems',
      },
    ],
  };

  const result = transform(data, map);
  console.log(result);
  return result;
}
